// A link to a platform file in a field (R-F6, R-C16): download by rights, or copy a link — temporary when the account's setting says so.

import { useToast } from '../ui/primitives.tsx';
import { Icon } from '../ui/icons.tsx';
import s from './fields.module.css';

const FILE = /^\/api\/files\/(forms\/[^?#\s]+)$/;
export const fileKeyOf = (v: unknown): string | null => (typeof v === 'string' ? FILE.exec(v.trim())?.[1] ?? null : null);

export function FileLink({ fileKey }: { fileKey: string }) {
  const toast = useToast();
  const copy = async (e: React.MouseEvent) => {
    e.stopPropagation();
    const r = await fetch('/api/files/link', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ key: fileKey }) }).catch(() => null);
    if (!r?.ok) { toast({ kind: 'error', text: 'Ссылку не выдать: файла нет или нет доступа' }); return; }
    const { url, expiresAt } = (await r.json()) as { url: string; expiresAt: string | null };
    await navigator.clipboard?.writeText(new URL(url, location.origin).href).catch(() => undefined);
    toast({ kind: 'info', text: expiresAt ? `Ссылка скопирована: открывается без входа до ${new Date(expiresAt).toLocaleTimeString('ru', { hour: '2-digit', minute: '2-digit' })}` : 'Ссылка скопирована: откроется у тех, кому доступна запись' });
  };
  return (
    <span className={s.fileLink}>
      <a className={s.link} href={`/api/files/${fileKey}`} onClick={(e) => e.stopPropagation()}><Icon name="download" size={13} />Файл</a>
      <button type="button" className={s.fileCopy} title="Скопировать ссылку" aria-label="Скопировать ссылку" onClick={(e) => void copy(e)}><Icon name="link" size={13} /></button>
    </span>
  );
}
